<div class="custom-blocks-section font-inter">
    <div class="image-container">
        <!-- <video class="custom-blocks-image" autoplay loop muted>
        <source src="assets/videos/blockvideo.webm" type="video/mp4">
      </video> -->
        <img src="assets/images/block3.png" class="custom-blocks-image" alt="Colorful toy blocks" />
        <div class="overlay"></div>
    </div>

    <div class="section-contianer container">
        <div class="section-content">
            <p class="section-title font-poppins">Custom Your Blocks</p>
            <p class="section-subtitle">
                Most toys end at the box. Ours begin there. Choose your colors, shapes, and patterns in our Design
                Studio to create blocks that are truly personal. It is a freedom. What will you create today?
            </p>
            <div class="button-container">
                <button mat-stroked-button class="start-design-btn" (click)="navigateToDesigner()">
                    Start Designing
                </button>
                <button mat-stroked-button class="customize-btn" (click)="navigateToCustomizePage()">Customize</button>
            </div>
        </div>
    </div>
</div>
